import {
	COUPON_FORM_ADMIN_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'

import addCoupon from 'root/src/client/logic/coupon/thunks/addCoupon'

export default {
	[COUPON_FORM_ADMIN_MODULE_ID]: [
		{
			action: addCoupon,
		},
	],
}
